/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { T as ToolbarTitle, d as defineCustomElement$1 } from './title.js';
const IonTitle = ToolbarTitle;
const defineCustomElement = defineCustomElement$1;
export { IonTitle, defineCustomElement };